export const errorMessages = {
	generic:
		'Sorry, something went wrong processing your request. Please try again.',
	invalidUser: 'This username / password combination is not valid.',
	expiredSession:
		'Your session has expired due to inactivity. Please log back in to continue.',
	expiredSessionEnforced:
		'Your session has expired due to inactivity. Please log out and log back in to continue.',
	userExists: `Looks like you're already registered. Please Log In with your username and password.`,
	userExistsWithLoginLink: async loginLink => {
		const { Link } = await import('react-router-dom');
		return (
			<>
				An account with the provided information already exists. Please try
				again or <Link to={loginLink}>sign in</Link> with your existing account.
			</>
		);
	},
	emailExists: `An account already exists with this email. Log In or Contact Us for help accessing your account.`,
	serverError: `We&#39;re sorry, we&#39;re experiencing an internal server problem. Please <strong>Contact Us</strong> to report this error and we will fix it as soon as possible.`,
	lockedUser:
		'Your account has been locked due to too many incorrect password attempts. Please reset your password to unlock your account.',
	selectRoleStepServerErrorPrefix: `We're sorry, we are unable to confirm your eligibility. If you feel this is incorrect, please contact us at`,
};

export const errorMessagesWithPhone = customerServicePhoneNumber => ({
	userNotElegible: `We&#39;re sorry, we are unable to confirm your eligibility. If you feel this is incorrect, please contact us at <strong>${customerServicePhoneNumber}</strong>.`,
});

export const validationMessages = {
	email: 'Please enter a valid email address.',
	firstName: 'Please enter a valid first name.',
	lastName: 'Please enter a valid last name.',
	dateOfBirth: 'Please enter a valid date of birth.',
	phone: 'Please enter a valid 10-digit phone number.',
	zip: 'Please enter a valid zip code.',
	pin: 'Please enter a pin.',
	taxIdNumber: 'Please enter a valid TIN.',
	confirmPassword: 'Passwords do not match.',
	securityAnswer: 'Please enter a valid security answer.',
	securityQuestion: 'Please select a valid security question.',
	username: 'Please enter a valid username.',
	usernameNotUnique: 'Sorry, this username is already taken.',
};
